import { LoaderFunctionArgs, redirect } from "react-router-dom";

import { MyDate, myAxios } from "src/components/common/functions";

export async function profitMarginLoader({ request }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => controller.abort());
    const url = new URL(request.url);
    const today = new MyDate().s();
    const monthStart = `${today.slice(0, 8)}01`;
    let shouldRedirect = false;
    const allowed = ["projectId", "projectManagerId", "summaryStart", "summaryEnd", "oh"];
    for (const [key] of url.searchParams) {
        if (!allowed.includes(key)) {
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }
    if (!url.searchParams.get("summaryStart")) {
        url.searchParams.set("summaryStart", monthStart);
        shouldRedirect = true;
    }
    if (!url.searchParams.get("summaryEnd")) {
        url.searchParams.set("summaryEnd", today);
        shouldRedirect = true;
    }
    if (!url.searchParams.get("oh")) {
        url.searchParams.set("oh", "1.54");
        shouldRedirect = true;
    }
    if (shouldRedirect) {
        throw redirect(url.pathname + "?" + url.searchParams.toString());
    }
    const formData = new FormData();
    for (const key of allowed) {
        const value = url.searchParams.get(key);
        if (value !== null && value !== "") formData.append(key, value);
    }
    const res = await myAxios({
        fileName: "profitMargin/readProfitMargin.php",
        formData,
        signal: controller.signal,
    });
    if (!res) throw redirect("..");
    return res.data;
}
